/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import {connect} from 'react-redux'
import {useHistory} from 'react-router'
import {useTranslation} from 'react-i18next'
import ReactS3Client from 'react-aws-s3-typescript'

import '../webshop/webshop.css'
import {KTSVG} from '../../../_metronic/helpers'
import DropImage from '../components/DropImage'
import {AppState} from '../../../setup/redux/Store'
import {
  BACKEND_UPLOAD_URL,
  BACKEND_API_URL,
  S3_BUCKET,
  REGION,
  ACCESS_KEY,
  SECRET_ACCESS_KEY,
  removeAllSession,
  DEFAULTTOKEN,
  BACKEND_API_V2,
} from '../../../config/config'
import {WebshopState} from '../personalorder/components/newComponents/types'
import {
  AmericanExpressSVG,
  ApplePaySVG,
  BpaySVG,
  AdvcashSVG,
  CardSVG,
  GPaySVG,
  MasterCardSVG,
  UnionPaySVG,
  VISASVG,
  EpsSVG,
  GiropaySVG,
  CreditCardSVG,
  NetellerOptionIcon,
  RapidOptionIcon,
  SkrillOptionIcon,
} from '../../../_metronic/helpers/components/svgs'
import CouponComponent, {CouponObject} from '../webshop/components/CouponComponent'
import {PaymentMethod, PaymentMethodSettings, getRandomPaymentMethod} from '~/lib/utils'

interface Props {
  setViewStatus: React.Dispatch<React.SetStateAction<number>>
  shoppingCart: Array<any>
  curUserInfo: any
  sponserUserName: string
  sponsorId: number
  sponsorFirstName: string
  sponsorSecondName: string
  state: WebshopState
}

function PaymentInfo({
  setViewStatus,
  shoppingCart,
  curUserInfo,
  sponserUserName,
  sponsorId,
  sponsorFirstName,
  sponsorSecondName,
  state,
}: Props) {
  const history = useHistory()
  const {t} = useTranslation()
  const [backStyle, setBackStyle] = useState('')
  const [curEuroRate, setCurEuroRate] = useState(1.024)
  const [addAddoressStyle, setAddAddressStyle] = useState('modal')
  const [curBillingAddress, setCurBillingAddress] = useState<Array<any>>([])
  const [curShoppingCart, setCurShoppingCart] = useState<Array<any>>([])
  const [totalPrice, setTotalPrice] = useState(0)
  const [curBillingStatus, setCurBillingStatus] = useState(-1)
  const [curUserToBilling, setCurUserToBilling] = useState(true)
  const [containBilling, setContainBilling] = useState(false)
  const [curTrustStatus, setCurTrustStatus] = useState(false)
  const [curCountryCode, setCurCountryCode] = useState('')
  const [curCreateSubLoading, setCurCreateSubLoading] = useState(false)

  // Legal Terms Flags
  const [curTermsStatus, setCurTermsStatus] = useState(false)
  const [curDisclaimerStatus, setCurDisclaimerStatus] = useState(false)
  const [curEmailStatus, setCurEmailStatus] = useState(false)

  // Coupon
  const [coupons, setCoupons] = useState<CouponObject[]>([])
  const [buyAsCoupon, setBuyAsCoupon] = useState<boolean>(false)

  // Personal Information
  const [curCompanyname, setCurCompanyname] = useState('')
  const [curFirstName, setCurFirstName] = useState('')
  const [curLastName, setCurLastName] = useState('')
  const [curStreet, setCurStreet] = useState('')
  const [curSuite, setCurSuite] = useState('')
  const [curZipcode, setCurZipcode] = useState('')
  const [curCity, setCurCity] = useState('')
  const [curCountry, setCurCountry] = useState('')
  const [curCountryId, setCurCountryId] = useState(0)

  // Payment methods
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>()
  const [collapsed, setCollapsed] = useState<PaymentMethod>()

  const [ccConfirm, setCcConfirm] = useState(false)
  const [ccPayStatus, setCcPayStatus] = useState(false)
  // MasterCard Information State
  const [curMasterCardInfo, setCurMasterCardInfo] = useState({
    method_publicname: '',
    short_desc: '',
    long_desc: '',
    sepaAvatar: '',
  })
  // Sepa Information State
  const [curSepaInfo, setCurSepaInfo] = useState({
    method_publicname: '',
    short_desc: '',
    long_desc: '',
    receiver: '',
    iban: '',
    swift: '',
    bankname: '',
    bankaddress: '',
    sepaAvatar: '',
  })
  // Coinbase Information State
  const curCoinbaseInfo = {
    method_publicname: 'Crypto',
    short_desc: 'BTC, DAI, ETH, LTC, USDC',
    long_desc: `<h3 style="text-align: left;"><span style="color: rgb(224, 62, 45);">Important:</span></h3><p style="text-align: left;">Please make sure that the price shown by the payment site is the amount that the destination wallet receives.</p><p style="text-align: left;">Some Exchanges/Wallets will deduct the network-fees from the amount you withdraw.</p><p style="text-align: left;"><span style="color: rgb(224, 62, 45);">Meaning, you have to manually respect the network fees to send the correct amount.</span></p><p style="text-align: left;"><br>If you miss this detail, the destination wallet will not receive the full payment.</p><p style="text-align: left;">When the system detects this underpayment, your order will not be marked as completed. Manual administration will be required in those cases.<br>If the transaction is not showing as successfull for you after 1 hour, please contact the Support at: <a href="mailto:support@be-infinity.com">support@be-infinity.com</a><br><br></p><table style="border-collapse: collapse; width: 100.057%; height: 117.563px;" border="1"><colgroup><col style="width: 49.923%;"><col style="width: 49.923%;"></colgroup><tbody><tr style="height: 19.5938px;"><td style="height: 19.5938px;"><strong>Coin</strong></td><td style="height: 19.5938px;"><strong>Network</strong></td></tr><tr style="height: 19.5938px;"><td style="height: 19.5938px;">Bitcoin ( BTC)&nbsp;</td><td style="height: 19.5938px;">Bitcoin Network</td></tr><tr style="height: 19.5938px;"><td style="height: 19.5938px;">Dai ( DAI )&nbsp;</td><td style="height: 19.5938px;">Ethereum network</td></tr><tr style="height: 19.5938px;"><td style="height: 19.5938px;">Ethereum ( ETH )&nbsp;</td><td style="height: 19.5938px;">Ethereum network</td></tr><tr style="height: 19.5938px;"><td style="height: 19.5938px;">Litecoin ( LTC )&nbsp;</td><td style="height: 19.5938px;">Litecoin network</td></tr><tr style="height: 19.5938px;"><td style="height: 19.5938px;">USD Coin ( USDC )&nbsp;</td><td style="height: 19.5938px;">Ethereum network</td></tr></tbody></table>`,
    sepaAvatar: 'images/paymentIcons/Coinbase Logo1664952017538.png',
  }
  // Trustly Information State
  const curTrustlyInfo = {
    method_publicname: 'Trustly',
    short_desc: 'Trustly',
    long_desc: '<p>Trustly</p>',
    sepaAvatar: 'images/paymentIcons/Trustly-logo1665648678417.png',
  }
  // CreditCard Information State
  const curCreditCardInfo = {
    method_publicname: 'Credit Card',
    short_desc: 'Credit Card',
    long_desc: '<p>Pay with Visa or Mastercard</p>',
    sepaAvatar: '/media/card-logos/cc.svg',
  }

  // View States about Payment methods
  const [paymentMethodSettings, setPaymentMethodSettings] = useState<PaymentMethodSettings>({
    cardinity: false,
    airwallex_eps: false,
    airwallex_giropay: false,
    airwallex_applepay: false,
    airwallex_googlepay: false,
    airwallex_cc: false,
    advcash: false,
    bpay: false,
    micropayment_prepay: false,
    micropayment_sofort: false,
    reap_cc: false,
    coinbase: false,
    skrill_rapid: false,
    skrill_cc: false,
    skrill_neteller: false,
    skrill: false,
  })

  // Get Countries Information
  const [curCountries, setCurCountries] = useState<Array<any>>([])
  const [unCheckedCountry, setUnCheckedCountry] = useState('')
  const [unCheckedCountryId, setUnCheckedCountryId] = useState(-1)

  const [hasBasicPlanGift, setHasBasicPlanGift] = useState(false)

  let shoppingCartWithCoupons = shoppingCart

  useEffect(() => {
    setHasBasicPlanGift(false)

    let tempTotal = 0
    let tempShoppingCart = []

    coupons.forEach((coupon) => {
      const {plan_id, coupon: couponCode} = coupon
      let plan = state.addons.find((item) => item.id === plan_id)
      if (plan) {
        !shoppingCartWithCoupons[1].some((p: {id: any}) => p.id === plan.id) &&
          shoppingCartWithCoupons[1].push(Object.assign({}, plan))
        return
      }
      plan = state.addons_addons.find((item) => item.id === plan_id)
      if (plan) {
        !shoppingCartWithCoupons[2].some((p: {id: any}) => p.id === plan.id) &&
          shoppingCartWithCoupons[2].push(Object.assign({}, plan))
        return
      }
      plan = state.basePlans.find((item) => item.id === plan_id)
      if (plan) {
        setHasBasicPlanGift(true)
        shoppingCartWithCoupons[0] = Object.assign({}, plan)
        return
      }
      plan = state.affiliatePlans.find((item) => item.id === plan_id)
      if (plan) {
        shoppingCartWithCoupons[3] = Object.assign({}, plan)
        return
      }
    })

    for (let i = 0; i < shoppingCartWithCoupons.length; i++) {
      if (i === 1 || i === 2) {
        for (let j = 0; j < shoppingCartWithCoupons[i].length; j++) {
          if (Object.keys(shoppingCartWithCoupons[i][j]).length > 0) {
            let tempData: any = {}
            const is_coupon = coupons.find(
              (coupon) => coupon.plan_id === shoppingCartWithCoupons[i][j].id
            )
            tempData.id = shoppingCartWithCoupons[i][j].id
            tempData.product_image = shoppingCartWithCoupons[i][j].product_image
            tempData.status = shoppingCartWithCoupons[i][j].status
            tempData.scheduled_time = shoppingCartWithCoupons[i][j].scheduled_time
            tempData.card_name =
              shoppingCartWithCoupons[i][j].card_name + (is_coupon ? ` ${is_coupon.coupon}` : '')
            tempData.card_description = shoppingCartWithCoupons[i][j].card_description
            tempData.long_description = shoppingCartWithCoupons[i][j].long_description
            tempData.checked_attributes = shoppingCartWithCoupons[i][j].checked_attributes
            tempData.unchecked_attributes = shoppingCartWithCoupons[i][j].unchecked_attributes
            tempData.price = shoppingCartWithCoupons[i][j].price
            tempData.discount_flag = is_coupon ? true : shoppingCartWithCoupons[i][j].discount_flag
            tempData.discount = is_coupon ? 0 : shoppingCartWithCoupons[i][j].discount
            tempData.type = shoppingCartWithCoupons[i][j].type
            tempData.subscription_length =
              shoppingCartWithCoupons[i][j].subscription_length.length || 0
            tempData.quantity = shoppingCartWithCoupons[i][j].quantity
            tempData.quantity_ignore_flag = shoppingCartWithCoupons[i][j].quantity_ignore_flag
            tempData.product_volume = shoppingCartWithCoupons[i][j].product_volume
            tempData.rank_volume = shoppingCartWithCoupons[i][j].rank_volume
            tempData.hpp_units = shoppingCartWithCoupons[i][j].hpp_units
            tempData.hpp_coupons = shoppingCartWithCoupons[i][j].hpp_coupons
            tempData.products = shoppingCartWithCoupons[i][j].products
            tempData.ea_flag = shoppingCartWithCoupons[i][j].ea_flag
            tempData.ea_license_id = shoppingCartWithCoupons[i][j].ea_license_id
            tempData.vps_image_name = shoppingCartWithCoupons[i][j].vps_image_name
            tempData.selLengthIndex = shoppingCartWithCoupons[i][j].selLengthIndex || 0
            tempData.type = (i === 1 && 'addon') || (i === 2 && 'addon_addon')
            tempShoppingCart.push(tempData)
            if (tempData.discount_flag === 0) tempTotal += parseFloat(tempData.price)
            else tempTotal += parseFloat(tempData.discount)
          }
        }
      } else {
        if (Object.keys(shoppingCartWithCoupons[i]).length > 0) {
          let tempData = shoppingCartWithCoupons[i]

          const is_coupon = coupons.find((coupon) => coupon.plan_id === tempData.id)
          if (is_coupon) {
            tempData.card_name = tempData.card_name + ` ${is_coupon.coupon}`
            tempData.discount_flag = true
            tempData.discount = 0
            tempTotal -= 15
          }
          if (i === 0) tempData.type = 'base'
          else if (i === 2) tempData.type = 'affiliate'

          tempShoppingCart.push(tempData)

          if (tempData.discount_flag === 0) tempTotal += parseFloat(tempData.price)
          else tempTotal += parseFloat(tempData.discount)
        }
      }
    }
    setTotalPrice(tempTotal + 15)
    setCurShoppingCart(tempShoppingCart)
    getTermFlag()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coupons])
  useEffect(() => {
    if (state.countrieSettings) setCurCountries(state.countrieSettings)
    if (curUserInfo && curUserInfo.countryId) getAllowedPaymentMethod(curUserInfo.countryId || 0)
    if (state.currencies)
      setCurEuroRate(state.currencies.find((item: any) => item.currency_code === 'EUR')?.value || 1)
  }, [state.countrieSettings, state.paymentSettings, state.currencies])

  const getAllowedPaymentMethod = async (countrySelId: number) => {
    const token = state.countrieSettings.find((item: any) => item.id === countrySelId) || {}
    setCurTrustStatus(true)
    setCurCountryCode(token.country_code)
    let paymentSetting = state.paymentSettings
    let statusFlag = false

    setPaymentMethodSettings({
      cardinity: token?.cardinity === 1 && paymentSetting?.cardinity_signup === 1,
      airwallex_eps: token?.airwallex === 1 && paymentSetting?.airwallex_eps_signup === 1,
      airwallex_giropay: token?.airwallex === 1 && paymentSetting?.airwallex_giropay_signup === 1,
      airwallex_applepay: token?.airwallex === 1 && paymentSetting?.airwallex_applepay_signup === 1,
      airwallex_googlepay:
        token?.airwallex === 1 && paymentSetting?.airwallex_googlepay_signup === 1,
      airwallex_cc: token?.airwallex === 1 && paymentSetting?.airwallex_cc_signup === 1,
      advcash: token?.advcash === 1 && paymentSetting?.advcash_signup === 1,
      bpay: token?.bpay === 1 && paymentSetting?.bpay_signup === 1,
      micropayment_prepay:
        token?.micropayment_banktransfer === 1 &&
        paymentSetting?.micropayment_banktransfer_signup === 1,
      micropayment_sofort:
        token?.micropayment_sofort === 1 && paymentSetting?.micropayment_sofort_signup === 1,
      reap_cc: token?.creditcard === 1 && paymentSetting?.reap_signup === 1,
      coinbase: token?.coinbase === 1 && paymentSetting?.coinbase_signup === 1,
      skrill_rapid: token?.skrill === 1 && paymentSetting?.skrill_signup_rapid === 1,
      skrill_cc: token?.skrill === 1 && paymentSetting?.skrill_signup_cc === 1,
      skrill_neteller: token?.skrill === 1 && paymentSetting?.skrill_signup_neteller === 1,
      skrill: token?.skrill === 1 && paymentSetting?.skrill_signup === 1,
    })
  }

  const getTermFlag = async () => {
    const resultData = await axios.post(
      `${BACKEND_API_URL}/getTermsflag`,
      {},
      {
        headers: {'x-access-token': `${DEFAULTTOKEN}`},
      }
    )
    const {token, result, auth} = resultData.data

    if (auth === false) {
      removeAllSession()
      history.push('/auth/login')
    } else if (result === 'success') {
      setCurEmailStatus(token[0]?.newletterflag === 1 ? true : false)
    }
  }
  const saveTermFlag = async () => {
    let termFlagReq = {
      newletterflag: curEmailStatus,
    }
    const resultData = await axios.post(`${BACKEND_API_URL}/saveTermsflag/`, termFlagReq, {
      headers: {'x-access-token': `${DEFAULTTOKEN}`},
    })
    let {auth} = resultData?.data
    if (auth === false) {
      removeAllSession()
      history.push('/auth/login')
    }
  }

  const handleCreateSub = async () => {
    let basePlan = {}
    let addonPlan: Array<any> = []
    let addon_addonPlan: Array<any> = []
    let affiliatePlan = {}
    let billingAddress = []
    let payment_method = ''
    setCurCreateSubLoading(true)

    for (let i = 0; i < curShoppingCart.length; i++) {
      if (curShoppingCart[i].type === 'base') basePlan = curShoppingCart[i]
      else if (curShoppingCart[i].type === 'affiliate') affiliatePlan = curShoppingCart[i]
      else if (curShoppingCart[i].type === 'addon') addonPlan.push(curShoppingCart[i])
      else if (curShoppingCart[i].type === 'addon_addon') addon_addonPlan.push(curShoppingCart[i])
    }
    curUserInfo.useStatus = curUserToBilling
    billingAddress = curBillingAddress

    let currency = 'USD'
    let paymentMethodVal = ''

    switch (paymentMethod) {
      case 'mastercard':
        paymentMethodVal = 'mastercard'
        break
      case 'creditcard':
        paymentMethodVal = 'creditcard'
        break
      case 'creditcard_2':
        paymentMethodVal =
          getRandomPaymentMethod(
            ['skrill', 'cardinity', 'airwallex'],
            [1, 5, 4],
            [
              paymentMethodSettings.skrill_cc,
              paymentMethodSettings.cardinity,
              paymentMethodSettings.airwallex_cc,
            ]
          ) || ''
        payment_method = 'ACC'
        break
      case 'airwallex_cc':
      case 'airwallex_googlepay':
      case 'airwallex_applepay':
        paymentMethodVal = 'airwallex'
        break
      case 'airwallex_giropay':
      case 'airwallex_eps':
        paymentMethodVal = 'airwallex'
        currency = 'EUR'
        break
      case 'skrill_rapid':
        paymentMethodVal = 'skrill'
        payment_method = 'OBT'
        break
      case 'skrill_neteller':
        paymentMethodVal = 'skrill'
        payment_method = 'NTL'
        break
      case 'skrill':
        paymentMethodVal = 'skrill'
        payment_method = ''
        break
      case 'micropayment_sofort':
        paymentMethodVal = 'micropayment'
        payment_method = 'sofort'
        break
      case 'micropayment_prepay':
        paymentMethodVal = 'micropayment'
        payment_method = 'prepay'
        break
      case 'coinbase':
        paymentMethodVal = 'coinbase'
        break
      case 'bpay':
        paymentMethodVal = 'bpay'
        break
      case 'advcash':
        paymentMethodVal = 'advcash'
        break
      case 'trustly':
        paymentMethodVal = 'trustly'
        break
      case undefined:
        setCurCreateSubLoading(false)
        swal({
          title: `Error`,
          text: `Please select payment method`,
          icon: 'error',
        })
        return
    }

    let statusUpload = true
    let uploadFileUrl = ''
    if (paymentMethodVal === 'sepa') {
      let s3Config = {
        bucketName: S3_BUCKET,
        dirName: '',
        region: REGION,
        accessKeyId: ACCESS_KEY,
        secretAccessKey: SECRET_ACCESS_KEY,
        s3Url: BACKEND_UPLOAD_URL,
      }
    }

    if (statusUpload === true) {
      const body = {
        webshop: {
          plan_ids: curShoppingCart.map((item) => {
            return {id: item.id, volume: item.subscription_length}
          }),
          payment_method_body: {
            currency_code: currency, //rapyd bank transfer only
            payment_method,
          },
          payment_method: paymentMethodVal,
          vat: 0,
          use_commission_wallet: false,
          amount_commission_wallet: 0,
          use_shopping_credit_wallet: false,
          amount_shopping_credit_wallet: 0,
          forward_url: `${window.location.origin}`,
          coupon_codes: coupons.map((item) => item.coupon),
        },
        user_name: curUserInfo.username,
        email: curUserInfo.email,
        password: curUserInfo.password,
        first_name: curUserInfo.firstname,
        second_name: curUserInfo.secondname,
        sponsor_id: sponsorId,
        country: curUserInfo.country,
        country_id: curUserInfo.countryId,
        cityaddress: curUserInfo.cityaddress,
        streetaddress: curUserInfo.streetaddress,
        suite: curUserInfo.suite,
        postalcode: curUserInfo.postalcode,
        company_name: '',
        timezone: curUserInfo.timezone,
        birth: curUserInfo.birth,
        billing_address: billingAddress,
        consent: curTermsStatus,
        terms: curDisclaimerStatus,
        notifications: curEmailStatus,
      }
      const response = await fetch(`${BACKEND_API_V2}/webshop/user/sign_up`, {
        method: 'POST',
        body: JSON.stringify(body),
      })
        .then((res) => {
          return res.json()
        })
        .catch((err) => {
          console.log(err)
        })
      if (!response) {
        setCurCreateSubLoading(false)
        return
      }
      if (response.status === 'error') {
        setCurCreateSubLoading(false)

        swal({
          title: `Error`,
          text: `${response.message}`,
          icon: 'error',
        })
        return
      }
      if (!response) {
        setCurCreateSubLoading(false)
        swal({
          title: `Internal Server Error`,
          text: `Please Try again`,
          icon: 'error',
        })
        return
      }
      // setCurCreateSubLoading(false)
      swal({
        title: `Please Wait`,
        text: `Redirecting to payment page`,
        icon: 'success',
      })
      if (paymentMethodSettings.reap_cc) {
        window.open('https://collect.reap.global/beinfinity', '_self')
        return
      }
      // localStorage.setItem('security_flag', '0')
      // localStorage.setItem('confirm_flag', '1')
      // localStorage.setItem('restriction_flag', "0")
      // localStorage.setItem('token', response.jwt)
      window.open(response.webshop.createPayment.paymentResponse.redirect_url, '_self')
    }
  }

  // Billing Address
  const handleAddressAdd = () => {
    setCurCompanyname('')
    setCurFirstName('')
    setCurLastName('')
    setCurStreet('')
    setCurSuite('')
    setCurZipcode('')
    setCurCity('')
    setCurCountry('')
    setCurCountryId(0)
    setCurBillingStatus(-1)

    setBackStyle('modal-backdrop show ')
    setAddAddressStyle('modal show billing-address-modal-show')
  }
  const handleAddressModalClose = () => {
    setBackStyle('')
    setAddAddressStyle('modal')
  }
  const handleBillingAddress = () => {
    let billingAddress = {
      index: curBillingAddress?.length,
      useStatus: false,
      companyname: curCompanyname,
      firstname: curFirstName,
      secondname: curLastName,
      streetaddress: curStreet,
      suite: curSuite,
      postalcode: curZipcode,
      cityaddress: curCity,
      country: curCountry,
      countryId: curCountryId,
    }

    if (curBillingStatus === -1) {
      setCurBillingAddress([...curBillingAddress, billingAddress])
    } else {
      let tempTotalBilling: Array<any> = []
      let containStatus = false

      for (let i = 0; i < curBillingAddress?.length; i++) {
        if (curBillingAddress[i]?.useStatus === true) containStatus = true

        if (i === curBillingStatus) {
          billingAddress.index = curBillingStatus
          billingAddress.useStatus = curBillingAddress[i]?.useStatus
          tempTotalBilling.push(billingAddress)
        } else {
          tempTotalBilling.push(curBillingAddress[i])
        }
      }
      setContainBilling(containStatus)
      setCurBillingAddress(tempTotalBilling)
    }

    setBackStyle('')
    setAddAddressStyle('modal')
  }
  const handleBillingDelete = (index: number) => {
    let tempTotalBilling: Array<any> = []
    let containStatus = false

    for (let i = 0; i < curBillingAddress?.length; i++) {
      if (i < index) {
        if (curBillingAddress[i]?.useStatus === true) containStatus = true

        tempTotalBilling.push(curBillingAddress[i])
      } else if (i > index) {
        if (curBillingAddress[i]?.useStatus === true) containStatus = true

        let tempBillingAddress = {
          index: curBillingAddress[i]?.index - 1,
          useStatus: curBillingAddress[i]?.useStatus,
          companyname: curBillingAddress[i]?.companyname,
          firstname: curBillingAddress[i]?.firstname,
          secondname: curBillingAddress[i]?.secondname,
          streetaddress: curBillingAddress[i]?.streetaddress,
          suite: curBillingAddress[i]?.suite,
          postalcode: curBillingAddress[i]?.postalcode,
          cityaddress: curBillingAddress[i]?.cityaddress,
          country: curBillingAddress[i]?.country,
          countryId: curBillingAddress[i]?.countryId,
        }

        tempTotalBilling.push(tempBillingAddress)
      }
    }

    setContainBilling(containStatus)
    setCurBillingAddress(tempTotalBilling)
  }
  const handleBillingEdit = (index: number) => {
    setCurCompanyname(curBillingAddress[index]?.companyname)
    setCurFirstName(curBillingAddress[index]?.firstname)
    setCurLastName(curBillingAddress[index]?.secondname)
    setCurStreet(curBillingAddress[index]?.streetaddress)
    setCurSuite(curBillingAddress[index]?.suite)
    setCurZipcode(curBillingAddress[index]?.postalcode)
    setCurCity(curBillingAddress[index]?.cityaddress)
    setCurCountry(curBillingAddress[index]?.country)
    setCurCountryId(curBillingAddress[index]?.countryId)
    setCurBillingStatus(index)

    let status = false
    for (let i = 0; i < curCountries.length; i++) {
      if (curCountries[i]?.id === curBillingAddress[index].countryId) {
        status = true
        break
      }
    }
    if (status === false && curCountries.length > 0) {
      setUnCheckedCountry(curBillingAddress[index].country)
      setUnCheckedCountryId(curBillingAddress[index].countryId)
    }

    setBackStyle('modal-backdrop show ')
    setAddAddressStyle('modal show billing-address-modal-show')
  }
  const handleUseAddress = (index: number, checkedStatus: boolean) => {
    let tempTotalBilling: Array<any> = []
    let containStatus = false

    if (checkedStatus === true) setCurUserToBilling(false)

    for (let i = 0; i < curBillingAddress?.length; i++) {
      if (i === index) {
        if (checkedStatus === true) containStatus = true

        let tempBillingAddress = {
          index: curBillingAddress[index]?.index,
          useStatus: checkedStatus,
          companyname: curBillingAddress[i]?.companyname,
          firstname: curBillingAddress[i]?.firstname,
          secondname: curBillingAddress[i]?.secondname,
          streetaddress: curBillingAddress[i]?.streetaddress,
          suite: curBillingAddress[i]?.suite,
          postalcode: curBillingAddress[i]?.postalcode,
          cityaddress: curBillingAddress[i]?.cityaddress,
          country: curBillingAddress[i]?.country,
          countryId: curBillingAddress[i]?.countryId,
        }

        tempTotalBilling.push(tempBillingAddress)
      } else {
        if (checkedStatus === true) {
          let tempBillingAddress = {
            index: curBillingAddress[i]?.index,
            useStatus: false,
            companyname: curBillingAddress[i]?.companyname,
            firstname: curBillingAddress[i]?.firstname,
            secondname: curBillingAddress[i]?.secondname,
            streetaddress: curBillingAddress[i]?.streetaddress,
            suite: curBillingAddress[i]?.suite,
            postalcode: curBillingAddress[i]?.postalcode,
            cityaddress: curBillingAddress[i]?.cityaddress,
            country: curBillingAddress[i]?.country,
            countryId: curBillingAddress[i]?.countryId,
          }

          tempTotalBilling.push(tempBillingAddress)
        } else {
          if (curBillingAddress[i]?.useStatus === true) containStatus = true

          tempTotalBilling.push(curBillingAddress[i])
        }
      }
    }

    getAllowedPaymentMethod(tempTotalBilling.find((item: any) => item.useStatus === true).countryId)
    setContainBilling(containStatus)
    setCurBillingAddress(tempTotalBilling)
  }
  const handleUserToBilling = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurUserToBilling(e.target.checked)

    let tempTotalBilling: Array<any> = []

    if (e.target.checked === true) {
      for (let i = 0; i < curBillingAddress?.length; i++) {
        let tempBillingAddress = {
          index: curBillingAddress[i]?.index,
          useStatus: false,
          companyname: curBillingAddress[i]?.companyname,
          firstname: curBillingAddress[i]?.firstname,
          secondname: curBillingAddress[i]?.secondname,
          streetaddress: curBillingAddress[i]?.streetaddress,
          suite: curBillingAddress[i]?.suite,
          postalcode: curBillingAddress[i]?.postalcode,
          cityaddress: curBillingAddress[i]?.cityaddress,
          country: curBillingAddress[i]?.country,
          countryId: curBillingAddress[i]?.countryId,
        }

        tempTotalBilling.push(tempBillingAddress)
      }

      setContainBilling(false)
      setCurBillingAddress(tempTotalBilling)
    }
  }

  const handleChangeCountry = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCurCountry(e.target.selectedOptions[0].text)
    setCurCountryId(parseInt(e.target.selectedOptions[0].value))
  }

  return (
    <>
      <div className='post d-flex flex-column-fluid shadow-sm' id='kt_post'>
        <div id='kt_content_container' className='container-xxl'>
          <div className='d-flex flex-column flex-lg-row'>
            <div className='flex-lg-row-fluid me-lg-15 order-2 order-lg-1 mb-10 mb-lg-0'>
              {/* Billing Address */}
              <div className='card shadow-sm mt-5 mb-5 mb-xl-10'>
                <div className='card-header'>
                  <div className='card-title'>
                    <h3>{t('ACCOUNT_BILLING_ADDRESS_TITLE')}</h3>
                  </div>
                </div>
                <div className='card-body'>
                  <div className='row gx-9 gy-6'>
                    <div className='col-xl-6'>
                      <div className='card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6'>
                        <div className='d-flex flex-column py-2'>
                          <div className='d-flex align-items-center fs-5 fw-bolder mb-3'>
                            {curUserInfo?.username}
                          </div>
                          <div className='fs-6 fw-bold text-gray-600'>
                            {curUserInfo?.firstname}&nbsp;&nbsp;{curUserInfo?.secondname}
                            <br />
                            {curUserInfo?.suite}&nbsp;&nbsp;{curUserInfo?.streetaddress}
                            <br />
                            {curUserInfo?.postalcode}&nbsp;&nbsp;{curUserInfo?.cityaddress}
                            <br />
                            {curUserInfo?.country}
                          </div>
                        </div>
                        <div className='d-flex align-items-center form-check form-check-custom form-check-solid py-2'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            checked={curUserToBilling}
                            onChange={handleUserToBilling}
                          />
                          <label className='form-check-label'>{t('SHOPPINGCART_CONTENT_10')}</label>
                        </div>
                      </div>
                    </div>
                    {curBillingAddress.map((item: any, i: number) => (
                      <div className='col-xl-6' key={i}>
                        <div className='card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6'>
                          <div className='d-flex flex-column py-2'>
                            <div className='d-flex align-items-center fs-5 fw-bolder mb-3'>
                              {item?.companyname}
                            </div>
                            <div className='fs-6 fw-bold text-gray-600'>
                              {item?.firstname}&nbsp;&nbsp;{item?.secondname}
                              <br />
                              {item?.suite}&nbsp;&nbsp;{item?.streetaddress}
                              <br />
                              {item?.postalcode}&nbsp;&nbsp;{item?.cityaddress}
                              <br />
                              {item?.country}
                            </div>
                          </div>
                          <div>
                            <div className='d-flex align-items-center py-2'>
                              <button
                                className='btn btn-sm btn-light btn-active-light-primary me-3'
                                onClick={() => handleBillingDelete(item?.index)}
                              >
                                {t('BTN_TEXT_DELETE')}
                              </button>
                              <button
                                className='btn btn-sm btn-light btn-active-light-primary'
                                onClick={() => handleBillingEdit(item?.index)}
                              >
                                {t('BTN_TEXT_EDIT')}
                              </button>
                            </div>
                            <div className='form-check form-check-custom form-check-solid mt-2 mb-2'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                checked={item?.useStatus}
                                onChange={(e) => handleUseAddress(item?.index, e.target.checked)}
                              />
                              <label className='form-check-label'>
                                {t('PERSONAL_SUBSCRIPTION_CUSTOM_DLG_RENEW_CHECK_USE_BILLING')}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className='col-xl-6'>
                      <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed flex-stack h-xl-100 mb-10 p-6'>
                        <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                          <div className='mb-3 mb-md-0 fw-bold'>
                            <h4 className='text-gray-900 fw-bolder pe-7'>
                              {t('PERSONAL_SUBSCRIPTION_CUSTOM_DLG_RENEW_ALERT_TITLE1')}
                            </h4>
                            <div className='fs-6 text-gray-700 pe-7'>
                              {t('PERSONAL_SUBSCRIPTION_CUSTOM_DLG_RENEW_ALERT_CONTENT1')}
                            </div>
                          </div>
                          <button className='btn btn-light-primary' onClick={handleAddressAdd}>
                            {t('ACCOUNT_BILLING_ADDRESS_BTN_ADD')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Payment methods */}
              <div className='card shadow-sm pt-3 mb-5 mb-lg-10'>
                <div className='card-header'>
                  <div className='card-title'>
                    <h2 className='fw-bolder'>{t('PERSONAL_SUBSCRIPTION_CUSTOM_SUBTITLE1_9')}</h2>
                  </div>
                </div>
                <div className='card-body pt-0'>
                  <div id='kt_create_new_payment_method'>
                    {/* CreditCards */}
                    {(paymentMethodSettings.cardinity ||
                      paymentMethodSettings.airwallex_cc ||
                      paymentMethodSettings.skrill_cc) && ( // airwallex and cardinity share credit card
                      <>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) =>
                                      p === 'creditcard_2' ? undefined : 'creditcard_2'
                                    )
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'creditcard_2' ? 'gen036.svg' : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              <CreditCardSVG className='me-4' />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Credit Card | Instant
                                </div>
                                <div className='text-muted'>
                                  <div className='flex gap-2'>
                                    {' '}
                                    <VISASVG /> <MasterCardSVG />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  checked={paymentMethod === 'creditcard_2'}
                                  onChange={() => setPaymentMethod('creditcard_2')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'creditcard_2' ? 'collapse fs-6' : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              Pay using a Credit or Master Card
                            </div>
                          </div>
                        </div>
                        <div className='separator separator-dashed'></div>
                      </>
                    )}
                    {/* Airwallex Credit Card Pay */}
                    {paymentMethodSettings.airwallex_cc && (
                      <>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) =>
                                      p === 'airwallex_cc' ? undefined : 'airwallex_cc'
                                    )
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'airwallex_cc' ? 'gen036.svg' : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              <CardSVG className='me-4' />

                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Amex & Union Pay | Instant
                                </div>
                                <div className='text-muted'>
                                  {/* Pay using any of your credit cards or Google Pay */}
                                  <div className='flex gap-2'>
                                    {' '}
                                    <UnionPaySVG /> <AmericanExpressSVG />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  checked={paymentMethod === 'airwallex_cc'}
                                  onChange={() => setPaymentMethod('airwallex_cc')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'airwallex_cc' ? 'collapse fs-6' : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              You can pay with any of your Credit Cards, including American Express
                            </div>
                          </div>
                        </div>
                        <div className='separator separator-dashed'></div>
                      </>
                    )}
                    {/* Rapid Bank Transfer  */}
                    {paymentMethodSettings.skrill_rapid && totalPrice * curEuroRate < 5000 && (
                      <>
                        <div className='separator separator-dashed'></div>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) =>
                                      p === 'skrill_rapid' ? undefined : 'skrill_rapid'
                                    )
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'skrill_rapid' ? 'gen036.svg' : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>{' '}
                              <RapidOptionIcon />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Rapid - Bank Transfer | Instant
                                </div>
                                <div className='text-muted'>
                                  Instant Bank Transfer powered by Rapid
                                </div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  name='payment_method'
                                  checked={paymentMethod === 'skrill_rapid'}
                                  onChange={() => setPaymentMethod('skrill_rapid')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'skrill_rapid' ? 'collapse fs-6' : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              Pay using SEPA Bank Transfer, this method may take up to 7 days to
                              process.
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {/* Bank Transfer  */}
                    {paymentMethodSettings.micropayment_prepay && (
                      <>
                        <div className='separator separator-dashed'></div>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) =>
                                      p === 'micropayment_prepay'
                                        ? undefined
                                        : 'micropayment_prepay'
                                    )
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'micropayment_prepay'
                                        ? 'gen036.svg'
                                        : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>{' '}
                              <img
                                src='/media/icons/duotune/finance/icon-prepay-en.svg'
                                className='w-40px me-3'
                                alt=''
                              />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Manual - Bank Transfer | 2-7 Days
                                </div>
                                <div className='text-muted'>Manual - Bank Transfer</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  name='payment_method'
                                  checked={paymentMethod === 'micropayment_prepay'}
                                  onChange={() => setPaymentMethod('micropayment_prepay')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'micropayment_prepay'
                                ? 'collapse fs-6'
                                : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              Pay using SEPA Bank Transfer, this method may take up to 7 days to
                              process.
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {/* SOFORT  */}
                    {paymentMethodSettings.micropayment_sofort &&
                      totalPrice * curEuroRate < 4999 && (
                        <>
                          <div className='separator separator-dashed'></div>
                          <div className='py-1'>
                            <div className='py-3 d-flex flex-stack flex-wrap'>
                              <div className='d-flex align-items-center collapsible toggle collapsed'>
                                <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                  <span
                                    className='svg-icon svg-icon-primary svg-icon-2'
                                    onClick={() =>
                                      setCollapsed((p) =>
                                        p === 'micropayment_sofort'
                                          ? undefined
                                          : 'micropayment_sofort'
                                      )
                                    }
                                  >
                                    <KTSVG
                                      path={`/media/icons/duotune/general/${collapsed === 'micropayment_sofort' ? 'gen036.svg' : 'gen035.svg'}`}
                                    />
                                  </span>
                                </div>{' '}
                                <img
                                  src='/media/icons/duotune/finance/onlnuebwsng_icon.png'
                                  className='w-40px me-3'
                                  alt=''
                                />
                                <div className='me-3'>
                                  <div className='d-flex align-items-center fw-bolder'>
                                    Onlineüberweisung - Online Banking | Instant
                                  </div>
                                  <div className='text-muted'>
                                    Onlineüberweisung - Online Bank Transfer
                                  </div>
                                </div>
                              </div>
                              <div className='d-flex my-3 ms-9'>
                                <label className='form-check form-check-custom form-check-solid me-5'>
                                  <input
                                    className='form-check-input'
                                    type='radio'
                                    name='payment_method'
                                    checked={paymentMethod === 'micropayment_sofort'}
                                    onChange={() => setPaymentMethod('micropayment_sofort')}
                                  />
                                </label>
                              </div>
                            </div>
                            <div
                              className={
                                collapsed !== 'micropayment_sofort'
                                  ? 'collapse fs-6'
                                  : 'collapse show fs-6'
                              }
                            >
                              <div className='mb-3 payment-long-desc'>
                                Pay using Onlineüberweisung Payment system, Instant Bank Transfer,
                                your account will be active instantly!
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    {/* Airwallex Giropay */}
                    {paymentMethodSettings.airwallex_giropay && (
                      <>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) =>
                                      p === 'airwallex_giropay' ? undefined : 'airwallex_giropay'
                                    )
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'micropayment_sofort'
                                        ? 'gen036.svg'
                                        : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              <GiropaySVG className='me-4' />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Giropay – {t('PERSONALORDER_CONTENT_29')} | {t('TEXT_INSTANT')}
                                </div>
                                <div className='text-muted'>Pay using Giropay</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  checked={paymentMethod === 'airwallex_giropay'}
                                  onChange={() => setPaymentMethod('airwallex_giropay')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'airwallex_giropay'
                                ? 'collapse fs-6'
                                : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              You can Pay using Giropay payment system
                            </div>
                          </div>
                        </div>
                        <div className='separator separator-dashed'></div>
                      </>
                    )}
                    {/* Airwallex Google Pay */}
                    {paymentMethodSettings.airwallex_googlepay && (
                      <>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) =>
                                      p === 'airwallex_googlepay'
                                        ? undefined
                                        : 'airwallex_googlepay'
                                    )
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'airwallex_giropay'
                                        ? 'gen036.svg'
                                        : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              <GPaySVG className='me-4' />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Google Pay | Instant
                                </div>
                                <div className='text-muted'>Pay using Google Pay</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  checked={paymentMethod === 'airwallex_googlepay'}
                                  onChange={() => setPaymentMethod('airwallex_googlepay')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'airwallex_googlepay'
                                ? 'collapse fs-6'
                                : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              You can Pay using any card connected to your Google Pay Account
                            </div>
                          </div>
                        </div>
                        <div className='separator separator-dashed'></div>
                      </>
                    )}
                    {/* Airwallex Apple Pay */}
                    {paymentMethodSettings.airwallex_applepay && (
                      <>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) =>
                                      p === 'airwallex_applepay' ? undefined : 'airwallex_applepay'
                                    )
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'airwallex_applepay'
                                        ? 'gen036.svg'
                                        : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              <ApplePaySVG className='me-4' />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Apple Pay | Instant
                                </div>
                                <div className='text-muted'>Pay using Apple Pay</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  checked={paymentMethod === 'airwallex_applepay'}
                                  onChange={() => setPaymentMethod('airwallex_applepay')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'airwallex_applepay'
                                ? 'collapse fs-6'
                                : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              You can Pay using any card connected to your Apple Pay Account
                            </div>
                          </div>
                        </div>
                        <div className='separator separator-dashed'></div>
                      </>
                    )}
                    {/* Airwallex eps */}
                    {paymentMethodSettings.airwallex_eps && curCountry === 'Austria' && (
                      <>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) =>
                                      p === 'airwallex_eps' ? undefined : 'airwallex_eps'
                                    )
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'airwallex_eps' ? 'gen036.svg' : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              <EpsSVG className='me-4' />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  eps | Instant
                                </div>
                                <div className='text-muted'>Pay using eps</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  checked={paymentMethod === 'airwallex_eps'}
                                  onChange={() => setPaymentMethod('airwallex_eps')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'airwallex_eps' ? 'collapse fs-6' : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              You can Pay using eps payment system
                            </div>
                          </div>
                        </div>
                        <div className='separator separator-dashed'></div>
                      </>
                    )}
                    {/* Crypto */}
                    {paymentMethodSettings.coinbase && (
                      <>
                        <div className='separator separator-dashed'></div>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) => (p === 'coinbase' ? undefined : 'coinbase'))
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'coinbase' ? 'gen036.svg' : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              {curCoinbaseInfo.sepaAvatar.length > 0 && (
                                <img
                                  src={BACKEND_UPLOAD_URL + curCoinbaseInfo.sepaAvatar}
                                  className='w-40px me-3'
                                  alt=''
                                />
                              )}
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  {curCoinbaseInfo.method_publicname} | ~1 Hour
                                </div>
                                <div className='text-muted'>{curCoinbaseInfo.short_desc}</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  name='payment_method'
                                  checked={paymentMethod === 'coinbase'}
                                  onChange={() => setPaymentMethod('coinbase')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'coinbase' ? 'collapse fs-6' : 'collapse show fs-6'
                            }
                          >
                            <div
                              className='mb-3 payment-long-desc'
                              dangerouslySetInnerHTML={{__html: curCoinbaseInfo.long_desc}}
                            />
                          </div>
                        </div>
                      </>
                    )}
                    {/* Binance Pay */}
                    {paymentMethodSettings.bpay && (
                      <>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) => (p === 'bpay' ? undefined : 'bpay'))
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'bpay' ? 'gen036.svg' : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              <BpaySVG />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Binance Pay | Instant
                                </div>
                                <div className='text-muted'>Pay using your Binance account</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  checked={paymentMethod === 'bpay'}
                                  onChange={() => setPaymentMethod('bpay')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'bpay' ? 'collapse fs-6' : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              Binance Pay enables instant purchases using any crypto currency held
                              on your Binance account.
                            </div>
                          </div>
                        </div>
                        <div className='separator separator-dashed'></div>
                      </>
                    )}
                    {/* Advcash */}
                    {paymentMethodSettings.advcash && (
                      <>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) => (p === 'advcash' ? undefined : 'advcash'))
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'advcash' ? 'gen036.svg' : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              <AdvcashSVG />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Volet | Instant
                                </div>
                                <div className='text-muted'>Pay using your Volet Wallet</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  checked={paymentMethod === 'advcash'}
                                  onChange={() => setPaymentMethod('advcash')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'advcash' ? 'collapse fs-6' : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              Volet enables instant purchases using any funds in your Volet Wallet.
                            </div>
                          </div>
                        </div>
                        <div className='separator separator-dashed'></div>
                      </>
                    )}
                    {/* Skrill Account */}
                    {paymentMethodSettings.skrill && (
                      <>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) => (p === 'skrill' ? undefined : 'skrill'))
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'skrill' ? 'gen036.svg' : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              <SkrillOptionIcon />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Skrill | Instant
                                </div>
                                <div className='text-muted'>Pay using your Skrill Account</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  checked={paymentMethod === 'skrill'}
                                  onChange={() => setPaymentMethod('skrill')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'skrill' ? 'collapse fs-6' : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              Skrill enables instant purchases using any funds in your Skrill
                              Account.
                            </div>
                          </div>
                        </div>
                        <div className='separator separator-dashed'></div>
                      </>
                    )}
                    {/* Neteller */}
                    {paymentMethodSettings.skrill_neteller && totalPrice * curEuroRate < 10000 && (
                      <>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) =>
                                      p === 'skrill_neteller' ? undefined : 'skrill_neteller'
                                    )
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'skrill_neteller' ? 'gen036.svg' : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              <NetellerOptionIcon />
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  Neteller | Instant
                                </div>
                                <div className='text-muted'>Pay using your Neteller Account</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  checked={paymentMethod === 'skrill_neteller'}
                                  onChange={() => setPaymentMethod('skrill_neteller')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'skrill_neteller'
                                ? 'collapse fs-6'
                                : 'collapse show fs-6'
                            }
                          >
                            <div className='mb-3 payment-long-desc'>
                              Neteller enables instant purchases using any funds in your Neteller
                              Account.
                            </div>
                          </div>
                        </div>
                        <div className='separator separator-dashed'></div>
                      </>
                    )}

                    {/* Trustly */}
                    {paymentMethodSettings.reap_cc && curTrustStatus && (
                      <div>
                        <div className='separator separator-dashed'></div>
                        <div className='py-1'>
                          <div className='py-3 d-flex flex-stack flex-wrap'>
                            <div className='d-flex align-items-center collapsible toggle collapsed'>
                              <div className='btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2'>
                                <span
                                  className='svg-icon svg-icon-primary svg-icon-2'
                                  onClick={() =>
                                    setCollapsed((p) => (p === 'trustly' ? undefined : 'trustly'))
                                  }
                                >
                                  <KTSVG
                                    path={`/media/icons/duotune/general/${
                                      collapsed === 'trustly' ? 'gen036.svg' : 'gen035.svg'
                                    }`}
                                  />
                                </span>
                              </div>
                              {curTrustlyInfo.sepaAvatar.length > 0 && (
                                <img
                                  src={BACKEND_UPLOAD_URL + curTrustlyInfo.sepaAvatar}
                                  className='w-40px me-3'
                                  alt=''
                                />
                              )}
                              <div className='me-3'>
                                <div className='d-flex align-items-center fw-bolder'>
                                  {curTrustlyInfo.method_publicname}
                                </div>
                                <div className='text-muted'>{curTrustlyInfo.short_desc}</div>
                              </div>
                            </div>
                            <div className='d-flex my-3 ms-9'>
                              <label className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  name='payment_method'
                                  checked={paymentMethod === 'trustly'}
                                  onChange={() => setPaymentMethod('trustly')}
                                />
                              </label>
                            </div>
                          </div>
                          <div
                            className={
                              collapsed !== 'trustly' ? 'collapse fs-6' : 'collapse show fs-6'
                            }
                          >
                            <div
                              className='mb-3 payment-long-desc'
                              dangerouslySetInnerHTML={{__html: curTrustlyInfo.long_desc}}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Products */}
              <div className='card shadow-sm card-flush pt-3 mb-5 mb-lg-10'>
                <div className='card-header'>
                  <div className='card-title'>
                    <h2 className='fw-bolder'>{t('SIDBAR_PRODUCTS_TITLE')}</h2>
                  </div>
                </div>
                <div className='card-body pt-0'>
                  <div className='table-responsive'>
                    <table
                      className='table align-middle table-row-dashed fs-6 fw-bold gy-4'
                      id='kt_subscription_products_table'
                    >
                      <thead>
                        <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                          <th className='min-w-300px'>{t('TEXT_PRODUCT')}</th>
                          <th className='min-w-100px'>{t('TEXT_PERIOD')}</th>
                          <th className='min-w-150px'>{t('TEXT_TOTALPRICE')}</th>
                          {/* <th className='min-w-70px text-end'>Remove&nbsp;</th> */}
                        </tr>
                      </thead>
                      <tbody className='text-gray-600'>
                        {curShoppingCart.map((item, key) => (
                          <tr key={key}>
                            <td>{item?.card_name}</td>
                            <td>
                              {item?.subscription_length === 0
                                ? 'Lifetime'
                                : (item?.selLengthIndex as number) > 23 && item?.type === 'addon'
                                  ? 24 + ` ${t('TEXT_MONTHS')}`
                                  : item?.type === 'addon'
                                    ? parseInt(item?.selLengthIndex) + 1 + ` ${t('TEXT_MONTHS')}`
                                    : item?.subscription_length + ` ${t('TEXT_MONTHS')}`}
                            </td>
                            <td>
                              {(item?.discount_flag as number) === 1
                                ? '$' + parseFloat(item?.discount).toFixed(2)
                                : '$' + parseFloat(item?.price).toFixed(2)}
                            </td>
                            {/* <td className='text-center cursor-pointer'>
                              <span
                                className='svg-icon svg-icon-1'
                                onClick={() => handleDelProduct(key)}
                              >
                                <KTSVG path='/media/icons/duotune/general/gen027.svg' />
                              </span>
                            </td> */}
                          </tr>
                        ))}
                        {curShoppingCart?.length > 0 && (
                          <tr>
                            <td>{t('TEXT_SIGNUP_FEE')}</td>
                            <td>{t('TEXT_ONE_TIME')}</td>
                            <td>$15</td>
                          </tr>
                        )}
                        {hasBasicPlanGift && (
                          <tr>
                            <td>{t('TEXT_SIGNUP_FEE')} waver</td>
                            <td>{t('TEXT_ONE_TIME')}</td>
                            <td>-$15</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <CouponComponent coupons={coupons} setCoupons={setCoupons} sign_up />
                  </div>
                </div>
              </div>
            </div>
            {/* Summary */}
            <div className='flex-column flex-lg-row-auto w-100 w-lg-250px w-xl-300px mt-5 mb-10 order-1 order-lg-2'>
              <div className='card card-flush shadow-sm pt-3 mb-0'>
                <div className='card-header'>
                  <div className='card-title'>
                    <h2>{t('PERSONAL_SUBSCRIPTION_CUSTOM_TITLE2')}</h2>
                  </div>
                </div>
                <div className='card-body pt-0 fs-6'>
                  <div className='mb-7'>
                    <h5 className='mb-3'>{t('TEXT_CUSTOMER_DETAILS')}</h5>
                    <div className='d-flex align-items-center mb-1'>
                      <span className='fw-bolder text-gray-800 text-hover-primary me-2'>
                        {curUserInfo?.firstname + ' ' + curUserInfo?.secondname}
                      </span>
                    </div>
                    <div className='row'>
                      <span className='fw-bold text-gray-600 text-hover-primary'>
                        {curUserInfo?.username}
                      </span>
                      <span className='fw-bold text-gray-600 text-hover-primary'>
                        {curUserInfo?.email}
                      </span>
                    </div>
                  </div>
                  <div className='separator separator-dashed mb-7'></div>
                  <div className='mb-7'>
                    <h5 className='mb-3'>{t('TEXT_TOTAL_PAYMENT')}</h5>
                    {/* <div className='mb-0'>
                      <span className='fw-bold text-gray-600'>
                        {(totalPrice * curEuroRate).toFixed(2) + '€'}
                      </span>
                    </div> */}
                    <div className='mb-0'>
                      <span className='fw-bold text-gray-600'>
                        {new Intl.NumberFormat('en-US', {
                          style: 'currency',
                          currency: 'USD',
                        }).format(totalPrice)}
                        {/* {'$' + totalPrice + ' @ ' + curEuroRate} */}
                      </span>
                    </div>
                  </div>
                  <div className='separator separator-dashed mb-7'></div>
                  <div className='mb-10'>
                    <h5 className='mb-3'>{t('TEXT_PAYMENT_DETAILS')}</h5>
                  </div>
                  <div className='separator separator-dashed mb-7'></div>
                  <div className='mb-10'>
                    <h5 className='mb-3'>{t('TEXT_LEGALTERM_TITLE')}</h5>
                    <div className='mb-0'>
                      <div className='form-check form-check-custom form-check-solid align-items-start mb-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          style={{border: '1px solid #0e0e122e'}}
                          checked={curTermsStatus}
                          onChange={(e) => setCurTermsStatus(e.target.checked)}
                        />
                        <label
                          className='form-check-label'
                          dangerouslySetInnerHTML={{__html: t('TEXT_LEGALTERM_CONTENT1')}}
                        />
                      </div>
                      <div className='form-check form-check-custom form-check-solid align-items-start mb-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          style={{border: '1px solid #0e0e122e'}}
                          checked={curDisclaimerStatus}
                          onChange={(e) => setCurDisclaimerStatus(e.target.checked)}
                        />
                        <label
                          className='form-check-label'
                          dangerouslySetInnerHTML={{__html: t('TEXT_LEGALTERM_CONTENT2')}}
                        />
                      </div>
                      <div className='form-check form-check-custom form-check-solid align-items-start mb-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          style={{border: '1px solid #0e0e122e'}}
                          checked={curEmailStatus}
                          onChange={(e) => setCurEmailStatus(e.target.checked)}
                        />
                        <label
                          className='form-check-label'
                          dangerouslySetInnerHTML={{__html: t('TEXT_LEGALTERM_CONTENT3')}}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='mb-0'>
                    <button
                      type='submit'
                      className='btn btn-primary'
                      id='kt_subscriptions_create_button'
                      disabled={
                        curTermsStatus === false ||
                        curDisclaimerStatus === false ||
                        (containBilling === false && curUserToBilling === false) ||
                        curCreateSubLoading === true ||
                        !paymentMethod
                      }
                      onClick={handleCreateSub}
                    >
                      {curCreateSubLoading === true ? (
                        <span className='indicator-label'>{t('TEXT_PLEASEWAIT')}</span>
                      ) : (
                        <span className='indicator-label'>{t('TEXT_CREATE_SUBSCRIPTION')}</span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Billing Address */}
      <div className={addAddoressStyle} tabIndex={-1} id='kt_modal_new_address' aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <div className='modal-content'>
            <div className='modal-header' id='kt_modal_new_address_header'>
              <h2>{t('ACCOUNT_BILLING_ADDRESS_TITLE')}</h2>
              <div
                className='btn btn-sm btn-icon btn-active-color-primary'
                data-bs-dismiss='modal'
                onClick={handleAddressModalClose}
              >
                <span className='svg-icon svg-icon-1'>
                  <KTSVG path='/media/icons/duotune/general/gen040.svg' />
                </span>
              </div>
            </div>
            <div className='modal-body py-10 px-lg-17'>
              <div
                className='scroll-y me-n7 pe-7'
                id='kt_modal_new_address_scroll'
                data-kt-scroll='true'
                data-kt-scroll-activate='{default: false, lg: true}'
                data-kt-scroll-max-height='auto'
                data-kt-scroll-dependencies='#kt_modal_new_address_header'
                data-kt-scroll-wrappers='#kt_modal_new_address_scroll'
                data-kt-scroll-offset='300px'
              >
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_BILLING_ADDRESS_DLG_COMPANYNAME')}
                  </label>
                  <input
                    type='text'
                    name='company name'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_BILLING_ADDRESS_DLG_COMPANYNAME')}
                    value={curCompanyname}
                    onChange={(e) => setCurCompanyname(e.target.value)}
                  />
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_OVERVIEW_DESC_FIRSTNAME')}
                  </label>
                  <input
                    type='text'
                    name='First name'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_OVERVIEW_DESC_FIRSTNAME')}
                    value={curFirstName}
                    onChange={(e) => setCurFirstName(e.target.value)}
                  />
                  {curFirstName.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_OVERVIEW_DESC_FIRSTNAME_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_BILLING_ADDRESS_DLG_LASTNAME')}
                  </label>
                  <input
                    type='text'
                    name='Last name'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_BILLING_ADDRESS_DLG_LASTNAME')}
                    value={curLastName}
                    onChange={(e) => setCurLastName(e.target.value)}
                  />
                  {curLastName.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_BILLING_ADDRESS_DLG_LASTNAME_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_OVERVIEW_DESC_STREET')}
                  </label>
                  <input
                    type='text'
                    name='street'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_OVERVIEW_DESC_STREET')}
                    value={curStreet}
                    onChange={(e) => setCurStreet(e.target.value)}
                  />
                  {curStreet.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_OVERVIEW_DESC_STREET_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_BILLING_ADDRESS_DLG_SUITE1')}
                  </label>
                  <input
                    type='text'
                    name='suite'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_BILLING_ADDRESS_DLG_SUITE2')}
                    value={curSuite}
                    onChange={(e) => setCurSuite(e.target.value)}
                  />
                  {curSuite.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_BILLING_ADDRESS_DLG_SUITE_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_OVERVIEW_DESC_ZIPCODE')}
                  </label>
                  <input
                    type='text'
                    name='postalcode'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_OVERVIEW_DESC_ZIPCODE')}
                    value={curZipcode}
                    onChange={(e) => setCurZipcode(e.target.value)}
                  />
                  {curZipcode.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_OVERVIEW_DESC_ZIPCODE_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_OVERVIEW_DESC_CITY')}
                  </label>
                  <input
                    type='text'
                    name='cityaddress'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('ACCOUNT_OVERVIEW_DESC_CITY')}
                    value={curCity}
                    onChange={(e) => setCurCity(e.target.value)}
                  />
                  {curCity.length === 0 && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{t('ACCOUNT_OVERVIEW_DESC_CITY_ALERT')}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className='d-flex flex-column mb-5 fv-row'>
                  <label className='required fs-5 fw-bold mb-2'>
                    {t('ACCOUNT_OVERVIEW_DESC_COUNTRY')}
                  </label>
                  <select
                    className='form-select form-select-lg form-select-solid'
                    data-control='select2'
                    data-placeholder='Select Country...'
                    value={curCountryId}
                    onChange={handleChangeCountry}
                    style={{
                      color:
                        unCheckedCountry.length > 0 && curCountryId === unCheckedCountryId
                          ? 'red'
                          : 'black',
                    }}
                  >
                    {curCountries
                      .filter((c) => c.status === 1)
                      .map((item, i) => (
                        <option value={item?.id} key={i} style={{color: 'black'}}>
                          {item?.country_name}
                        </option>
                      ))}
                    {unCheckedCountry.length > 0 && (
                      <option value={unCheckedCountryId} style={{color: 'red'}}>
                        {unCheckedCountry}
                      </option>
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className='modal-footer flex-center'>
              <button className='btn btn-light me-3' onClick={handleAddressModalClose}>
                {t('BTN_TEXT_DISCARD')}
              </button>
              <button
                className='btn btn-primary'
                disabled={
                  curFirstName.length === 0 ||
                  curLastName.length === 0 ||
                  curStreet.length === 0 ||
                  curSuite.length === 0 ||
                  curZipcode.length === 0 ||
                  curCity.length === 0
                }
                onClick={handleBillingAddress}
              >
                <span className='indicator-label'>{t('BTN_TEXT_CONFIRM')}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={backStyle}></div>
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  shoppingCart: state.webshop.shoppingCart,
  curUserInfo: state.webshop.curUserInfo,
  sponserUserName: state.webshop.sponserUserName,
  sponsorId: state.webshop.sponsorId,
  sponsorFirstName: state.webshop.sponsorFirstName,
  sponsorSecondName: state.webshop.sponsorSecondName,
})

export default connect(mapStateToProps, {})(PaymentInfo)
